'use client'
import React, { useEffect, useMemo, useState } from 'react'
import QRCodeUtil from 'qrcode'
const SmallAppLogo =
  'data:image/png;base64,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'

const generateMatrix = (value: string, errorCorrectionLevel: any) => {
  const arr = Array.prototype.slice.call(
    QRCodeUtil.create(value, { errorCorrectionLevel }).modules.data,
    0
  )
  const sqrt = Math.sqrt(arr.length)
  return arr.reduce(
    (rows, key, index) =>
      (index % sqrt === 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows,
    []
  )
}
function makeQrcodeSvgStr({
  text,
  size = 160,
  logo = SmallAppLogo,
  logoSize = 46,
  ecl = 'M'
}: QrcodeProps): string {
  const dots: any = []
  const matrix = generateMatrix(text, ecl)
  const cellSize = size / matrix.length
  const qrList = [
    { x: 0, y: 0 },
    { x: 1, y: 0 },
    { x: 0, y: 1 }
  ]
  qrList.forEach(({ x, y }) => {
    const x1 = (matrix.length - 7) * cellSize * x
    const y1 = (matrix.length - 7) * cellSize * y
    for (let i = 0; i < 3; i++) {
      dots.push(`<rect
        fill="${i % 2 !== 0 ? 'white' : 'black'}"
        height="${cellSize * (7 - i * 2)}"
        rx="${(i - 0.5) * -6 + (i === 0 ? 2 : 0)}"
        ry="${(i - 0.5) * -6 + (i === 0 ? 2 : 0)}"
        width="${cellSize * (7 - i * 2)}"
        x="${x1 + cellSize * i}"
        y="${y1 + cellSize * i}"
      />`)
    }
  })
  const clearArenaSize = Math.floor((logoSize + 3) / cellSize)
  const matrixMiddleStart = matrix.length / 2 - clearArenaSize / 2
  const matrixMiddleEnd = matrix.length / 2 + clearArenaSize / 2 - 2
  matrix.forEach((row: any, i: any) => {
    row.forEach((_: any, j: any) => {
      if (matrix[i][j]) {
        if (
          !(
            (i < 7 && j < 7) ||
            (i > matrix.length - 8 && j < 7) ||
            (i < 7 && j > matrix.length - 8)
          )
        ) {
          if (
            !(
              i > matrixMiddleStart &&
              i < matrixMiddleEnd &&
              j > matrixMiddleStart &&
              j < matrixMiddleEnd &&
              i < j + clearArenaSize / 2 &&
              j < i + clearArenaSize / 2 + 1
            )
          ) {
            dots.push(`<circle
              cx="${i * cellSize + cellSize / 3}"
              cy="${j * cellSize + cellSize / 3}"
              fill="black"
              r="${cellSize / 3}"
            />`)
          }
        }
      }
    })
  })
  const logoPosition = size / 2 - logoSize / 2 - 0
  const svgstr = `<svg xmlns="http://www.w3.org/2000/svg" height="${size}" width="${size}" viewBox="0 0 ${size} ${size}">
    <defs><clipPath id="clip-logo"><rect x="${logoPosition}" y="${logoPosition}" height="${logoSize}" width="${logoSize}" /></clipPath></defs>
    ${dots.join('')}
    ${
      logo &&
      `<image
        clipPath="url(#clip-logo)"
        x="${logoPosition}" y="${logoPosition}"
        height="${logoSize}"
        href="${logo}"
        width="${logoSize}"
      />`
    }
  </svg>`
  return svgstr
}

function delay(time: number) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true)
    }, time)
  })
}

async function makeQrcodeUrl(props: QrcodeProps): Promise<string> {
  const { size = 500 } = props
  // logo && (props.logo = await downloadByData(logo))
  props.logo = SmallAppLogo
  const svgstr = makeQrcodeSvgStr(props)
  const img = new Image()
  const canvas = document.createElement('canvas')
  canvas.width = size * 2
  canvas.height = size * 2
  img.crossOrigin = 'anonymous'
  img.src = `data:image/svg+xml;base64, ${window.btoa(svgstr)}`
  return new Promise((resolve) => {
    img.onload = async () => {
      await delay(100)
      const ctx = canvas.getContext('2d')
      if (ctx) {
        ctx.fillStyle = 'white'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
        const url = canvas.toDataURL('image/jpeg')
        resolve(url)
      }
    }
  })
}

function loadImage(url: string): Promise<string> {
  return new Promise((resolve) => {
    fetch(url)
      .then((res) => {
        res.blob().then((blob) => {
          const fileReader = new FileReader()
          fileReader.addEventListener('load', function (e) {
            const base64 = e.target?.result as string
            resolve(base64 || '')
          })
          fileReader.readAsDataURL(blob)
        })
      })
      .catch(() => resolve(''))
  })
}
async function makeBaseQrcodeUrl({ text, size = 500 }: QrcodeProps) {
  return QRCodeUtil.toDataURL(text, {
    type: 'image/jpeg',
    width: size,
    margin: 2
  })
}

export default React.memo(function Qrcode({
  text,
  size,
  logo,
  logoSize,
  ecl,
  type,
  ...props
}: QrcodeProps & React.ImgHTMLAttributes<HTMLImageElement>) {
  const url = useQrcodeUrl({ text, size, logo, logoSize, ecl, type })
  if (!url) return null
  return <img {...props} src={url} alt='qr' />
})
export function useCircleQrcodeSvgStr(props: QrcodeProps) {
  return useMemo(() => {
    return makeQrcodeSvgStr(props)
  }, [props])
}
export function useQrcodeUrl({ text, size, logo, logoSize, ecl, type = 'circle' }: QrcodeProps) {
  const [url, setUrl] = useState('')
  useEffect(() => {
    const qrcodeProps = { text, size, logo, logoSize, ecl }
    if (text) {
      if (type === 'circle') {
        makeQrcodeUrl(qrcodeProps).then((res) => {
          setUrl(res)
        })
      } else {
        makeBaseQrcodeUrl(qrcodeProps).then((res) => {
          setUrl(res)
        })
      }
    }
  }, [text, type, size, logoSize, logo, ecl])
  if (!url) return null
  return url
}
interface QrcodeProps {
  text: string
  size?: number
  logo?: string
  logoSize?: number
  ecl?: string
  type?: 'circle' | 'base'
}
